import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { MarketResearchComponent } from './market-research/market-research.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HealthcareComponent } from './healthcare/healthcare.component';
import { EducationComponent } from './education/education.component';
import { ItandbankingComponent } from './itandbanking/itandbanking.component';
import { HotelandrestaurentsComponent } from './hotelandrestaurents/hotelandrestaurents.component';
import { EventandentertainmentComponent } from './eventandentertainment/eventandentertainment.component';
import { PricingComponent } from './pricing/pricing.component';
import { HowItWorksComponent } from './how-it-works/how-it-works.component';
import { RetailManufacturingComponent } from './retail-manufacturing/retail-manufacturing.component';
import { CustomerExperienceComponent } from './customer-experience/customer-experience.component';
import { EmployeeExperienceComponent } from './employee-experience/employee-experience.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { TemplatesComponent } from './templates/templates.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { FeaturesComponent } from './features/features.component';
import { FaqComponent } from './faq/faq.component';
import { GdprComponent } from './gdpr/gdpr.component';
import { SecurityComponent } from './security/security.component';
import { TakedownPolicyComponent } from './takedown-policy/takedown-policy.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { PrivacyNoticeComponent } from './privacy-notice/privacy-notice.component';
import { UnsubscribesComponent } from './unsubscribes/unsubscribes.component';
import { NpsSurveyComponent } from './nps-survey/nps-survey.component';
import { TemplateDetailsComponent } from './template-details/template-details.component';
import { TemplateQuestionDetailsComponent } from './template-question-details/template-question-details.component';
import { TempQuestionComponent } from './temp-question/temp-question.component';
import { BlogComponent } from './blog/blog.component';
import { BlogDetailsComponent } from './blog-details/blog-details.component';
import { DeveloperComponent } from './developer/developer.component';



const routes: Routes = [
  {
    path: '',
    pathMatch: 'full', 
    redirectTo: '/home',
  },
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'how-it-works',
    component: HowItWorksComponent,
  },
  {
    path: 'healthcare',
    component: HealthcareComponent,
  },
  {
    path: 'education',
    component: EducationComponent,
  },
  {
    path: 'it-ites',
    component: ItandbankingComponent,
  },
  {
    path: 'hotel-restaurants',
    component: HotelandrestaurentsComponent,
  },
  {
    path: 'event-entertainment',
    component: EventandentertainmentComponent,
  },
  {
    path: 'retail-manufacturing',
    component: RetailManufacturingComponent,
  },
  {
    path: 'pricing',
    component: PricingComponent,
  },
  {
    path: 'field-survey-and-market-research',
    component: MarketResearchComponent,
  },
  {
    path: 'customer-experience',
    component: CustomerExperienceComponent,
  },
  {
    path: 'employee-experience',
    component: EmployeeExperienceComponent,
  },
  {
    path: 'cookie-policy',
    component: CookiePolicyComponent,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'templates',
    component: TemplatesComponent,
  },
  {
    path : 'features',
    component : FeaturesComponent,
  },
  {
    path : 'faq',
    component : FaqComponent,
  },
  {
    path : 'gdpr',
    component : GdprComponent,
  },
  {
    path : 'security-policy',
    component : SecurityComponent,
  },
  {
    path : 'terms-of-services',
    component : TermsOfServiceComponent,
  },

  {
    path : 'unsubscribes',
    component : UnsubscribesComponent,
  },

  {
    path : 'nps-survey',
    component : NpsSurveyComponent,
  },
  
  {
    path : 'templates-details',
    component :TemplateDetailsComponent,
  },

  {
    path : 'templates-question-details',
    component :TemplateQuestionDetailsComponent,
  },

  {
    path : 'temp-question',
    component :TempQuestionComponent,
  }, 
  
  {
    path : 'blog',
    component :BlogComponent,
  },

  {
    path : 'blog-details/:id/:title',
    component :BlogDetailsComponent,
  },
  {
    path : 'developer',
    component :DeveloperComponent,
  },
  {
    //Wild Card Route for 404 request
    path: '**',
    pathMatch: 'full', 
    redirectTo: '/404',
  },
  {
    path : '404',
    component :PageNotFoundComponent,
  }
  
];


@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class PagesRoutingModule { }
